export default "__VITE_ASSET__DXOp35e2__"